const body = document.body;
const colorShiftTriggers = document.querySelectorAll('.trigger__color--shift');

function isElementInViewport (element) {
    const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
    const rect = element.getBoundingClientRect();
    const elementTop = rect.top;
    const elementBottom = rect.bottom;
    const topOffset = viewportHeight * 0.4;
    const bottomOffset = viewportHeight * 0.6;
    
    return (
        elementTop <= bottomOffset && 
        elementBottom >= topOffset
    );
}

function handler() {
    let inViewPort = Array.from(colorShiftTriggers).some(entry => {
        return isElementInViewport(entry);
    });

    if (inViewPort) {       
        body.classList.add('body__color--dark');
        body.classList.remove('body__color--light');
    } else {
        body.classList.add('body__color--light');
        body.classList.remove('body__color--dark');
    }
}

jQuery(window).on('DOMContentLoaded load resize scroll', handler);
